var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8ExpandArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "50px",
    height: "50px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(249.77507,-0.02726) rotate(90) scale(5.12,5.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.98438,12.96875c-0.53125,0.01563 -1.03125,0.23438 -1.39844,0.61719l-18.58594,18.58594l-18.58594,-18.58594c-0.37891,-0.38672 -0.89453,-0.60547 -1.4375,-0.60547c-0.8125,0 -1.54297,0.49609 -1.84766,1.25c-0.30859,0.75391 -0.125,1.61719 0.45703,2.18359l20,20c0.78125,0.78125 2.04688,0.78125 2.82813,0l20,-20c0.59375,-0.57031 0.78125,-1.44922 0.46094,-2.21094c-0.31641,-0.76172 -1.06641,-1.25 -1.89062,-1.23437z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8ExpandArrowLeft);
export default __webpack_public_path__ + "static/media/icons8-expand-arrow-left.4e38e027a5937e5f534d578614d3e84c.svg";
export { ForwardRef as ReactComponent };